import { createAction, props } from '@ngrx/store';
import { FileModel } from '../../../models/file/file.model';
import { ProjectExpenseModel } from '../../../models/finance/expense.model';

// FETCH
export const fetchProjectExpenses = createAction('[Project Expenses] Fetch Expenses');

export const setProjectExpenses = createAction(
  '[Project Expenses] Set Expenses',
  props<{ payload: ProjectExpenseModel[] }>(),
);

// ADD
export const addProjectExpense = createAction(
  '[Project Expenses] Add Expense',
  props<{ payload: ProjectExpenseModel }>(),
);

export const projectExpenseAdded = createAction(
  '[Project Expenses] Expense Added',
  props<{
    payload: ProjectExpenseModel;
    newAttachment?: FileModel | null;
  }>(),
);

// UPDATE
export const updateProjectExpense = createAction(
  '[Project Expenses] Update Expense',
  props<{ payload: { updatedProjectExpense: ProjectExpenseModel; oldAttachment: FileModel } }>(),
);

export const projectExpenseUpdated = createAction(
  '[Project Expenses] Expense Updated',
  props<{
    payload: ProjectExpenseModel;
    oldAttachment: FileModel | null;
    newAttachment: FileModel | null;
  }>(),
);

// DELETE
export const deleteProjectExpense = createAction(
  '[Project Expenses] Delete Expense',
  props<{ payload: ProjectExpenseModel | ProjectExpenseModel[] }>(),
);

export const projectExpenseDeleted = createAction(
  '[Project Expenses] Expense Deleted',
  props<{ payload: ProjectExpenseModel | ProjectExpenseModel[] }>(),
);

// ERROR
export const httpFail = createAction('[Project Expenses] Http fail', props<{ payload: string }>());
